const waterSupplyRoutes = [
  {
    path: '/watersupply/admin/login',
    name: 'waterSupplyAdminLogin',
    component: () => import('@/views/watersupply/admin/Login.vue'),
    meta: { layout: 'auth', sidebar: false, footer: false }
  },
  {
    path: '/watersupply',
    component: () => import('@/components/layout/watersupply/WaterSupplyLayout.vue'),
    children: [
      // admin
      {
        path: 'admin',
        name: 'waterSupplyAdminSurvey',
        component: () => import('@/views/watersupply/waterSurveyAdminList.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false, authorize: ['admin'], requiredSubId: 4, loginPath: '/watersupply/admin/login' }
      },
      {
        path: 'admin/watersupplymanagement',
        name: 'waterSupplyManagement',
        props: true,
        component: () => import('@/views/watersupply/admin/WaterSupplyManagement.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false, authorize: ['admin'], requiredSubId: 4, loginPath: '/watersupply/admin/login' }
      },
      {
        path: 'admin/watersupplylist',
        name: 'waterSupplyList',
        component: () => import('@/views/watersupply/admin/WaterSupplyList.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false, authorize: ['admin'], requiredSubId: 4, loginPath: '/watersupply/admin/login' }
      },
      {
        path: 'admin/watersupplysamplelist',
        name: 'waterSupplySampleList',
        component: () => import('@/views/watersupply/admin/WaterSupplySampleList.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false, authorize: ['admin'], requiredSubId: 4, loginPath: '/watersupply/admin/login' }
      },
      {
        path: 'admin/users/new',
        name: 'waterSupplyAdminNewUser',
        component: () => import('@/views/watersupply/admin/NewUser.vue'),
        meta: {
          layout: 'auth',
          sidebar: false,
          footer: false,
          authorize: ['admin'],
          requiredSubId: 4,
          loginPath: '/watersupply/admin/login'
        }
      },
      // end admin
      {
        path: '',
        name: 'waterSupplyHome',
        component: () => import('@/views/watersupply/waterSurveyList.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      {
        path: 'admin/survey/:id/:mode',
        name: 'waterSupplySurveyAdminDetail',
        props: true,
        component: () => import('@/views/watersupply/survey/WaterSupplySurvey.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false, authorize: ['admin'], requiredSubId: 4, loginPath: '/watersupply/admin/login' }
      },
      {
        path: 'survey',
        name: 'waterSupplySurvey',
        component: () => import('@/views/watersupply/survey/WaterSupplySurvey.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      {
        path: 'admin/sample/:id/:mode(view|edit)',
        alias: 'sample/:id/:mode(view|edit)',
        name: 'waterSupplySampleAdminDetail',
        props: true,
        component: () => import('@/views/watersupply/survey/WaterSupplySample.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false, authorize: ['admin'], requiredSubId: 4, loginPath: '/watersupply/admin/login' }
      },
      {
        path: 'sample',
        name: 'waterSupplySample',
        props: true,
        component: () => import('@/views/watersupply/survey/WaterSupplySample.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      {
        path: 'locations',
        name: 'waterSupplyLocations',
        props: true,
        component: () => import('@/views/watersupply/map/waterSupplyMap.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      
      // end waterQualityRoutes
    ]
  }
];

export default waterSupplyRoutes;
